/**
 * @param {*} str
 * @returns {boolean}
 */
export function isNonEmptyString(str) {
  return typeof str === "string" && str.length > 0;
}

/**
 * @param {any} str
 * @returns boolean
 */
export function isTrimmedStringNonEmpty(str) {
  return typeof str === "string" && str.trim().length > 0;
}
